<script>
    import {clickOutside} from "../lib/clickOutside";
    import app from "../stores/app";
    import user from "../stores/user";
    import {router} from '../lib/Router/Router.svelte';
    import {USER_ROLE} from "../lib/constants";

    export let onLogOut = null;

    let path = "";
    let activePath = '';
    let userId = null;

    let menu = [
        {
            id: 'calendar',
            name: 'CALENDAR',
            link: `/app/calendar`,
            icon: 'calendar',
            visible: true,
            user: [USER_ROLE.ADMIN, USER_ROLE.USER, USER_ROLE.AGENT],
        },
        {
            id: 'reservations',
            name: 'RESERVATIONS',
            link: `/app/reservations`,
            icon: 'reservations',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'agents',
            name: 'AGENTS',
            link: `/app/agents`,
            icon: 'agent',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'stop-sales',
            name: 'STOP SALES',
            link: `/app/stop-sales`,
            icon: 'stop-sales',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'users',
            name: 'USERS',
            link: `/app/users`,
            icon: 'users',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        {
            id: 'settings',
            name: 'SETTINGS',
            link: `/app/settings`,
            icon: 'settings',
            visible: true,
            user: [USER_ROLE.ADMIN],
        },
        // {
        //     id: 'logout',
        //     name: 'LOGOUT',
        //     icon: 'logout',
        //     visible: true,
        //     // user: [USER_ROLE.ADMIN],
        // },
        // {
        //     id: 'settings',
        //     name: 'SETTINGS',
        //     icon: 'gear-solid',
        //     menu: [
        //         {
        //             id: 'pages',
        //             name: 'SITE PAGES',
        //             link: `/app/pages`,
        //         },
        //     ],
        //     visible: true,
        //     user: [USER_ROLE.ADMIN],
        //     menu_expanded: false,
        // }
    ];

    const pathFromLink = (link) => {
        return link.replace(window.location.origin, "");
    }

    const toggleMenu = (menu_id) => {
        menu.map(item => {
            if (item.menu) {
                if (item.id === menu_id) {
                    item.menu_expanded = !item.menu_expanded;
                } else {
                    item.menu_expanded = false;
                }
            }
        });
        menu = menu;
    }

    const onMenuItemClick = (event) => {
        event.preventDefault();
        let a = null;
        if (event.target.href) {
            a = event.target;
        } else {
            a = event.target.closest('a');
        }
        let link = pathFromLink(a.href);
        $app.menuExpanded = 0;
        activePath = link;
        router.go(link)();
    }

    const collapseMenu = () => {
        if ($app.menuExpanded > 0) {
            $app.menuExpanded--;
        }
    }

    const initializeMenu = () => {
        menu.map(item => {
            item.visible = item.user == null || item.user.indexOf($user.role) > -1;
            if (item.menu) {
                item.menu.map(subItem => {
                    subItem.visible = subItem.user == null || (subItem.user && subItem.user.indexOf($user.role) > -1);
                });
            }
        });
        menu = menu;
    }

    activePath = pathFromLink(window.location.href);

    $: {
        if (userId != $user.id) {
            userId = $user.id;
            initializeMenu();
        }

        if (path !== activePath) {
            // expand current menu
            let arr = activePath.split("/");
            menu.map(item => {
                if (item.menu) {
                    item.menu.map(subItem => {
                        if (arr.indexOf(subItem.id) > -1) {
                            item.menu_expanded = true;
                        }
                    });
                }
            });
            path = activePath;
        }
    }
</script>

<aside class:expanded={ $app.menuExpanded > 0 }>
    <div class="app-header">
        header
    </div>
    <div class="app-menu" use:clickOutside on:click_outside="{ collapseMenu }">
        <div class="app-menu-content">
            {#each menu as item}
                {#if item.visible}
                    {#if item.menu}
                        <div class="app-menu-dropdown">
                            <div class="app-menu-item" on:click="{ () => toggleMenu(item.id) }">
                                <div class="icon">
                                    <img src="/assets/icons/navigation/{ item.icon }.svg" alt="menu icon">
                                </div>
                                <div class="caption">{ item.name }</div>
                            </div>
                            {#if item.menu_expanded}
                                <div class="app-menu-item-dropdown">
                                    {#each item.menu as subItem}
                                        <a href="{ subItem.link }" class="app-menu-item"
                                           class:link-active={ path === subItem.link }
                                           on:click="{ onMenuItemClick }">
                                            <span class="caption">{ subItem.name }</span>
                                        </a>
                                    {/each}
                                </div>
                            {/if}
                        </div>
                    {:else}
                        <a href="{ item.link }" class="app-menu-item" class:link-active={ path === item.link }
                           on:click="{ onMenuItemClick }">
                        <span class="icon">
                            <img src="/assets/icons/navigation/{ item.icon }.svg" alt="menu icon">
                        </span>
                            <span class="caption">{ item.name }</span>
                        </a>
                    {/if}
                {/if}
            {/each}
            <button class="app-menu-item" on:click={onLogOut}>
                <span class="icon">
                    <img src="/assets/icons/navigation/logout.svg" alt="logout">
                </span>
                <span class="caption">Logout</span>
            </button>
        </div>
    </div>
</aside>


<style>
    aside {
        position: fixed;
        height: 100vh;
        transition: .3s all ease;
        z-index: 5000;
    }

    .app-header {
        height: var(--header-height);
    }

    .app-menu {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
        border-right: 1px solid #c6d2d9;
        transition: .3s all ease;
        overflow-y: auto;
    }

    .app-menu:before {
        position: absolute;
        content: " ";
        display: block;
        clear: both;
        top: 0;
        bottom: 0;
        left: 0;
        width: 5px;
        background: #03a9f4;
    }

    .app-menu .app-menu-content {
        width: 100%;
    }

    .app-menu-dropdown {
        position: relative;
    }

    .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
        padding-left: 50px;
    }

    @media (max-width: 576px) {
        aside {
            width: 100%;
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 577px) and (max-width: 999px) {
        aside {
            width: var(--aside-width);
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        aside {
            width: 54px;
        }

        aside:hover, aside.expanded {
            width: var(--aside-width);
        }

        .app-menu {
            width: 100%;
            overflow-x: hidden;
        }

        .app-menu .app-menu-content {
            width: var(--aside-width);
        }

        .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
            display: none;
        }

        aside:hover .app-menu-dropdown .app-menu-item-dropdown .app-menu-item,
        aside.expanded .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
            display: block;
        }
    }

    @media (min-width: 1025px) {
        aside {
            width: var(--aside-width);
        }
    }

    .app-menu-item {
        position: relative;
        display: flex;
        align-items: center;
        color: #1c1d1d;
        border-left: 5px solid #03a9f4;
        white-space: nowrap;
        padding: 15px;
        cursor: pointer;
        overflow: hidden;
        width: 100%;
        border-top: none;
        border-bottom: none;
        border-right: none;
        background: inherit;
    }

    .app-menu-item .icon {
        display: block;
        width: 18px;
        line-height: 1;
        margin-right: 15px;
    }

    .app-menu-item .icon img {
        width: 100%;
    }

    .app-menu-item .caption {
        display: block;
    }

    .app-menu-item:hover {
        background: #e4eaee;
        border-left-color: #0277bd;
    }

    .app-menu-item.link-active {
        border-left-color: #0277bd;
    }
</style>